// test2271
(2271 && 0);
